<template>
  <div class="plv-ia-qn-new-edit" :class="{'plv-ia-qn-new-edit--full-preview': isFullPreview}">
    <Loading v-if="loading"/>
    <template v-else>
      <SidebarNew
        v-show="!isFullPreview"
        :lang="lang"
        :editing-data="editingData"
        @add-question="addQuestion"
      />
      <div class="plv-ia-qn-new-edit-right">
        <QuestionnaireSetting
          v-show="!isPreview"
          ref="QuestionnaireSetting"
          class="plv-ia-qn-new-edit-right__content"
          :editing-data="editingData"
          :lang="lang"
        />
        <QuestionnairePreview
          v-show="isPreview"
          class="plv-ia-qn-new-edit-right__content"
          :editing-data="editingData"
          :is-full-preview="isFullPreview"
          :lang="lang"
          @show-edit-questionnaire="setIsPreview(false)"/>
        <div v-if="isFullPreview" class="plv-ia-qn-new-edit-bottom-handle">
          <div v-if="isFullPreviewEdit">
            <button v-if="editingData.status === STATUS.NOT_SENDED" class="plv-ia-common-btn plv-ia-common-btn-cancel" @click="setIsPreview(false)">{{ t('plvIA.questionnaire.editLabel') }}</button>
          </div>
          <div style="text-align: center;" :style="isFullPreviewPublish ? '' : 'flex: 1;'">
            <button v-if="isFullPreviewPublish"
                    class="plv-ia-common-btn plv-ia-common-btn-blue"
                    @click="startQuestionnaire"
                    style="margin-right: 16px;">
              {{ boolToStatus(editingData, STATUS.NOT_SENDED) ? t('plvIA.questionnaire.publishLabel') : t('plvIA.questionnaire.rePublishLabel')}}
            </button>
            <button class="plv-ia-common-btn plv-ia-common-btn-cancel" @click="quiteEdit">{{ t('plvIA.questionnaire.exitPreview') }}</button>
          </div>
        </div>
        <div v-else class="plv-ia-qn-new-edit-bottom-handle">
          <div>
            <button v-show="isPreview" class="plv-ia-common-btn plv-ia-common-btn-cancel" @click="setIsPreview(false)">{{ t('plvIA.questionnaire.edit') }}</button>
            <button v-show="!isPreview" class="plv-ia-common-btn plv-ia-common-btn-cancel" @click="setIsPreview(true)">{{ t('plvIA.questionnaire.previewLabel') }}</button>
          </div>
          <div v-if="!isFullPreview">
            <button class="plv-ia-common-btn plv-ia-common-btn-blue" style="margin-right: 15px;" @click="saveQuestionnaire">{{ t('plvIA.common.save') }}</button>
            <button class="plv-ia-common-btn plv-ia-common-btn-cancel" @click="beforeEdit">{{ t('plvIA.common.exit') }}</button>
          </div>
        </div>
      </div>
    </template>

    <!-- 编辑中，退出提示 -->
    <PopupConfirm
      ref="delete-qn-modal"
      :tips="t('plvIA.questionnaire.editingPopupTip')"
      :ensure-txt="t('plvIA.common.confirm')"
      :cancel-txt="t('plvIA.common.cancel')"
      :ensure-btn-cls="'plv-ia-btn-new plv-ia-btn-orange-2 pws-vclass-btn-orange-2'"
      @ensure="quiteEdit"
      @cancel="toggleDeleteQnModal(false)"
    />
  </div>
</template>

<script>
import SidebarNew from './SidebarNew.vue';
import QuestionnaireSetting from './QuestionnaireSetting';
import QuestionnairePreview from './QuestionnairePreview';
import { getQuestionnaireModel, STEP, STATUS, parseSaveQuestionnaire } from '@/assets/app/questionnaire/helper';
import Loading from '../../../components/loading/Loading';
import Locale from '@/mixins/locale';
import PopupConfirm from '@/components/popup/Confirm';
import { isEqual } from 'lodash-es';
import commonMixin from '../../app-mixin';

export default {
  name: 'QuestionnaireEdit',
  props: {
    questionnaireId: [String, null],
    core: {
      type: Object,
      required: true
    },
    privacy: {
      type: Object,
    },
    isFullPreview: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [Locale, commonMixin],
  components: {
    QuestionnaireSetting,
    SidebarNew,
    QuestionnairePreview,
    Loading,
    PopupConfirm
  },
  computed: {
    // 全屏预览时，是否可以编辑
    isFullPreviewEdit() {
      return this.isFullPreview && (this.editingData.status === STATUS.NOT_SENDED || this.editingData.status !== STATUS.SENDED);
    },
    // 全屏预览时，是否可以发布
    isFullPreviewPublish() {
      return this.isFullPreview && this.editingData.status !== STATUS.SENDED;
    }
  },
  data() {
    const defaultOption = {
      name: '问卷标题',
      desc: '问卷简介',
    };
    return {
      STATUS,
      STEP,
      editingData: getQuestionnaireModel(defaultOption),
      isPreview: this.isFullPreview,
      loading: false,
      originData: null
    };
  },
  async beforeMount() {
    if (this.questionnaireId) {
      this.loading = true;
      try {
        this.editingData = await this.core.getQuestionnaireDetail(this.questionnaireId);
        this.editingData.privacy = this.privacy;
        this.originData = JSON.parse(JSON.stringify(this.editingData));
      } catch (error) {
        this.$iaMessage.default(error.message);
      } finally {
        this.loading = false;
      }
    }
  },
  methods: {
    boolToStatus(item, status) {
      return item.status === status;
    },
    addQuestion(item) {
      this.isPreview = false;
      this.editingData.questions.push(item);
      this.$nextTick(() => {
        // 滚动到最底部
        const dom = document.querySelector('.plv-ia-qn-new-edit-right__content');
        dom.scrollTop = dom.scrollHeight;
      });
    },
    beforeEdit() {
      if (isEqual(this.originData, this.editingData)) {
        this.quiteEdit();
      } else {
        this.toggleDeleteQnModal(true);
      }
    },
    quiteEdit() {
      this.$emit('change-current-step', STEP.QUESTIONNAIRE_LIST);
    },
    setIsPreview(bool) {
      this.isPreview = bool;
      this.$emit('update:isFullPreview', false);
    },
    async saveQuestionnaire() {
      if (!this.checkQuestionnaire()) {
        this.isPreview = false;
        return;
      }
      const data = parseSaveQuestionnaire(this.editingData);
      this.$emit('save-questionnaire', data);
    },
    startQuestionnaire() {
      this.$emit('start-questionnaire', this.editingData, STEP.QUESTIONNAIRE_LIST, false);
    },
    checkQuestionnaire() {
      return this.$refs.QuestionnaireSetting.checkQuestionnaire();
    },
    toggleDeleteQnModal(show) {
      show ? this.$refs['delete-qn-modal'].show() : this.$refs['delete-qn-modal'].hide();
    },
  }
};
</script>

<style lang="scss">
.plv-ia-qn-new-edit {
  display: flex;
  height: 100%;
  .plv-ia-popup {
    z-index: 1000;
  }
}
.plv-ia-qn-new-edit--full-preview {
  .plv-ia-qn-new-preview {
    overflow: auto;
    padding: 16px 110px;
  }
  .plv-ia-qn-new-edit-bottom-handle {
    padding: 0 110px;
  }
}
.plv-ia-qn-new-edit-right {
  flex: 1;
  display: flex;
  position: relative;
  height: 100%;
  padding-bottom: 60px;
  box-sizing: border-box;
}
.plv-ia-qn-new-edit-bottom-handle {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 60px;
  background-color: #FFFFFF;
}

</style>
